import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { GitBranch, Terminal, BookOpen } from 'lucide-react';

/**
 * Домашняя страница с приветствием и обзором курса
 */
export default function HomePage() {
  return (
    <div className="flex h-full flex-col">
      {/* Hero section */}
      <div className="flex flex-1 items-center justify-center">
        <div className="mx-auto max-w-3xl px-6 text-center">
          {/* Git logo */}
          <div className="mb-8 flex justify-center">
            <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-git-orange shadow-lg">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="white">
                <path d="M23.546 10.93L13.067.452c-.604-.603-1.582-.603-2.188 0L8.708 2.627l2.76 2.76c.645-.215 1.379-.07 1.889.441.516.515.658 1.258.438 1.9l2.658 2.66c.645-.223 1.387-.078 1.9.435.721.72.721 1.884 0 2.604-.719.719-1.881.719-2.6 0-.539-.541-.674-1.337-.404-1.996L12.86 8.955v6.525c.176.086.342.203.488.348.713.721.713 1.883 0 2.6-.719.721-1.889.721-2.609 0-.719-.719-.719-1.879 0-2.598.182-.184.387-.317.605-.406V8.835c-.217-.091-.424-.222-.6-.401-.545-.545-.676-1.342-.396-2.009L7.636 3.7.45 10.881c-.6.605-.6 1.584 0 2.189l10.48 10.477c.604.604 1.582.604 2.186 0l10.43-10.43c.605-.603.605-1.582 0-2.187" />
              </svg>
            </div>
          </div>

          <h1 className="mb-4 text-4xl font-bold tracking-tight">Добро пожаловать в Git Mastery</h1>
          <p className="mb-8 text-xl text-muted-foreground">
            Интерактивный курс для изучения Git изнутри. Практикуйтесь в браузерном терминале с
            визуализацией каждого действия.
          </p>

          <div className="mb-12">
            <Link to="/lesson/1-1">
              <Button size="lg" className="gap-2">
                <BookOpen className="h-5 w-5" />
                Начать обучение
              </Button>
            </Link>
          </div>

          {/* Features */}
          <div className="grid gap-6 md:grid-cols-3">
            <div className="rounded-lg border bg-card p-6 text-left">
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-area-working/10">
                <Terminal className="h-5 w-5 text-area-working" />
              </div>
              <h3 className="mb-2 font-semibold">Браузерный терминал</h3>
              <p className="text-sm text-muted-foreground">
                Выполняйте Git команды в реальном терминале прямо в браузере
              </p>
            </div>

            <div className="rounded-lg border bg-card p-6 text-left">
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-area-staging/10">
                <GitBranch className="h-5 w-5 text-area-staging" />
              </div>
              <h3 className="mb-2 font-semibold">Визуализация</h3>
              <p className="text-sm text-muted-foreground">
                Наблюдайте как меняется граф коммитов и ветки в реальном времени
              </p>
            </div>

            <div className="rounded-lg border bg-card p-6 text-left">
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-git-orange/10">
                <BookOpen className="h-5 w-5 text-git-orange" />
              </div>
              <h3 className="mb-2 font-semibold">Структурированный курс</h3>
              <p className="text-sm text-muted-foreground">
                5 модулей с теорией и практикой от основ до продвинутых техник
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
